import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { useAuth } from "@/context/AuthContext";
import { rememberVantaggiVisit } from "@/lib/attribution";
import { Hero, MoreThanAccount, AlreadyAvailable, TodayPerks, SignupBlock, Finale } from "@/components/vantaggi/Sections";

// Sezioni modulari: perché registrarsi, vantaggi già attivi (stesso catalogo coupon), invito finale.
const SECTIONS = [Hero, MoreThanAccount, AlreadyAvailable, TodayPerks, SignupBlock, Finale];

export default function Vantaggi() {
  const { user, loading } = useAuth();
  const { search } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useEffect(() => { if (!loading && !user) rememberVantaggiVisit(search); }, [loading, user, search]);
  return (
    <div data-testid="vantaggi-page">
      <SEO
        rawTitle="Registrati. Readoo diventa tuo. | Readoo"
        description="Readoo è gratuito per tutti. Registrati per personalizzare le notizie, salvarle, seguire le tue squadre, ritrovare meteo e oroscopo e accedere ai vantaggi già attivi."
      />
      {SECTIONS.map((S, i) => <S key={i} />)}
    </div>
  );
}
